<template>
    <v-container fluid style="padding: 0px;">
        <v-card class="mx-auto pa-5" :max-width="$vuetify.breakpoint.smAndDown ? 900 : 800" outlined
            style="background: #F7F5F5; border-radius: 30px; border: 2px solid #05435B ;">

            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo IW39_0DMTOCETC</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="IW39_0DMTOCETC.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(0, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="IW39_0DMTOCETC.xlsx" label="Archivo IW39_0DMTOCETC" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(0, $event)" show-size></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo ZPMR0005_ODMTOCTEC</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="ZPMR0005_ODMTOCTEC.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(1, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="ZPMR0005_ODMTOCTEC.xlsx" label="Archivo ZPMR0005_ODMTOCTEC" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(1, $event)" show-size></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo ZPMRO006_HES</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="ZPMRO006_HES.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(2, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="ZPMRO006_HES.xlsx" label="Archivo ZPMRO006_HES" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(2, $event)" show-size></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <span class="font-weight-black text-h7 mr-5">Archivo ZPMR0007_MAT</span>
                </v-col>
                <v-col v-if="!$vuetify.breakpoint.mobile" cols="6">
                    <v-file-input placeholder="ZPMR0007_MAT.xlsx" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(3, $event)" show-size></v-file-input>
                </v-col>
                <v-col v-if="$vuetify.breakpoint.mobile" cols="12">
                    <v-file-input placeholder="ZPMR0007_MAT.xlsx" label="Archivo ZPMR0007_MAT" clearable dense outlined style="height: 35px;"
                        accept=".xls,.xlsx" @change="updateFile(3, $event)" show-size></v-file-input>
                </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
                <v-col cols="12" style="display: flex; justify-content: center; padding-top: 0px;">
                    <v-btn color="success" class="mt-4 rounded-button" @click="validar()">
                        Validar
                    </v-btn>
                </v-col>
            </v-row>
            <v-row style="margin-top: 0px;margin-bottom: 10px;" v-if="archivosGenerados.length > 0">
                <v-spacer></v-spacer>
                <!-- Iterar sobre archivosGenerados -->
                <v-col v-for="(archivo, index) in archivosGenerados" :key="archivo.id" cols="12"
                    class="d-flex align-center" style="height: 40px;">
                    <!-- Mostrar nombre del archivo -->
                    <v-spacer></v-spacer>
                    <v-col cols="8">
                        <span class="font-weight-black text-h8">{{ archivo.nombreFisico }}</span>
                    </v-col>

                    <!-- Botón para descargar -->
                    <v-col cols="2" class="text-right">
                        <v-btn density="compact" @click="descargar(archivo.id, archivo.nombreFisico)">
                            <v-icon style="color:#04395a">mdi-file-download-outline</v-icon>
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>

import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';

export default {
    data() {
        return {
            fromDateMenu1: false, // Controla el menú de la fecha "Desde"
            fromDateMenu2: false, // Controla el menú de la fecha "Hasta"
            fechaDesde: null, // Fecha seleccionada para "Desde"
            fechaHasta: null, // Fecha seleccionada para "Hasta"
            borradoPedido: true,
            valid: false,
            files: [null, null, null, null], // Archivos: [ODM, SOLPEDS, AVANCE INICIAL]
            archivosGenerados: []
        };
    },
    computed: {
        formattedDesde() {
            return this.fechaDesde
                ? new Date(this.fechaDesde + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
        formattedHasta() {
            return this.fechaHasta
                ? new Date(this.fechaHasta + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
    },
    methods: {
        validateFechaDesde(value) {
            if (this.fechaHasta && new Date(value) > new Date(this.fechaHasta)) {
                this.fechaDesde = null;
                alert("La fecha de inicio no puede ser mayor que la fecha de fin.");
            } else {
                this.fechaDesde = value;
            }
            this.fromDateMenu1 = false;
        },
        validateFechaHasta(value) {
            if (this.fechaDesde && new Date(value) < new Date(this.fechaDesde)) {
                this.fechaHasta = null;
                alert("La fecha de fin no puede ser menor que la fecha de inicio.");
            } else {
                this.fechaHasta = value;
            }
            this.fromDateMenu2 = false;
        },
        updateFile(index, file) {
            // Actualiza el archivo correspondiente en el arreglo `files`
            this.files[index] = file;
        },
        isExcelFile(file) {
            // Verifica si el archivo tiene extensión válida
            const allowedExtensions = [".xls", ".xlsx"];
            const fileName = file.name.toLowerCase();
            return allowedExtensions.some(ext => fileName.endsWith(ext));
        },

        async validar() {
            this.archivosGenerados = [];
            try {
                SwalService.loading('Validando...', 'Por favor espere.');
                if (!this.files.every(file => file !== null)) {
                    SwalService.close();
                    await new Promise(resolve => setTimeout(resolve, 100));
                    await SwalService.alert('Debe cargar todos los campos para poder continuar')
                    return;
                }
                // Realizar solicitud POST al backend para autenticación
                const response = await apiService.post("/programa-trabajos/inicia-proceso", {
                    idProceso: null,
                    tipoProceso: 5,
                    idUsuario: 2
                });

                // Maneja la respuesta
                const respuesta = response.data;
                if (respuesta.success) {
                    const datos = {
                        archivos: [
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 12,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 13,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 14,
                            },
                            {
                                id: null,
                                nombreLogico: null,
                                nombreFisico: null,
                                ruta: null,
                                fechaCarga: null,
                                proceso: respuesta.proceso,
                                tipoArchivo: 15,
                            },

                        ],
                    };

                    // Crear un FormData para enviar los archivos y los datos juntos
                    const formData = new FormData();

                    // Agregar los archivos a FormData (asegurando que los archivos sean seleccionados por el usuario)
                    formData.append("files", this.files[0]);
                    formData.append("files", this.files[1]);
                    formData.append("files", this.files[2]);
                    formData.append("files", this.files[3]);

                    // Agregar los datos serializados en formato JSON
                    formData.append("datosAdjunto", JSON.stringify(datos.archivos));

                    // Enviar los datos y los archivos al endpoint
                    const response2 = await apiService.post("/files/upload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    // Manejar la respuesta de la carga de archivos
                    const uploadResponse = response2.data;

                    const response3 = await apiService.post("/programa-trabajos/ejecuta-script", {
                        idProceso: respuesta.proceso.idProceso,
                        tipoProceso: 5,
                        idUsuario: 2
                    });

                    const ejecutaScript = response3.data;
                    if (ejecutaScript.success) {
                        this.archivosGenerados = ejecutaScript.archivos;
                        SwalService.close();
                        SwalService.success('Validación Completada', 'El archivo generado ya se encuentra disponible para descargar');
                    } else {
                        SwalService.close();
                        await new Promise(resolve => setTimeout(resolve, 100));
                        SwalService.error(ejecutaScript.error);
                    }

                } else {
                    SwalService.close();
                }

            } catch (error) {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.error('Error al cargar datos', 'Ocurrió un problema.');
            }
        },
        async descargar(id, fileName) {
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFile(`/files/${id}`, fileName);
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.success('Simulación Completada', 'El archivo simulado ya se encuentra disponible para descargar');
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        }
    },
};
</script>

<style scoped>
.v-menu__content {
    z-index: 9000 !important;
    position: absolute !important;
}
</style>